export const Vest = [
    {
        "id": 40,
        "Title": "IES-2024-40",
        "ImageSource": "/Boxing/boxing vest/1.jpg",
        "Category": "Boxing Vest"
    },
    {
        "id": 41,
        "Title": "IES-2024-41",
        "ImageSource": "/Boxing/boxing vest/2.jpg",
        "Category": "Boxing Vest"
    },
    {
        "id": 42,
        "Title": "IES-2024-42",
        "ImageSource": "/Boxing/boxing vest/3.jpg",
        "Category": "Boxing Vest"
    },
    {
        "id": 43,
        "Title": "IES-2024-43",
        "ImageSource": "/Boxing/boxing vest/4.jpg",
        "Category": "Boxing Vest"
    },
    {
        "id": 44,
        "Title": "IES-2024-44",
        "ImageSource": "/Boxing/boxing vest/5.jpg",
        "Category": "Boxing Vest"
    },
    {
        "id": 45,
        "Title": "IES-2024-45",
        "ImageSource": "/Boxing/boxing vest/6.jpg",
        "Category": "Boxing Vest"
    },
    {
        "id": 46,
        "Title": "IES-2024-46",
        "ImageSource": "/Boxing/boxing vest/7.jpg",
        "Category": "Boxing Vest"
    },
    {
        "id": 47,
        "Title": "IES-2024-47",
        "ImageSource": "/Boxing/boxing vest/8.jpg",
        "Category": "Boxing Vest"
    },
    {
        "id": 48,
        "Title": "IES-2024-48",
        "ImageSource": "/Boxing/boxing vest/9.jpg",
        "Category": "Boxing Vest"
    }
];
